/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

// this import must be before Vue components otherwise the selectors
// priority is wrong (e.g. .modal-close)
// TODO will be transferred in later PR
/* eslint-disable-next-line no-restricted-imports */
import '@/design/app.scss';
import '@/components/lhn/lhn_layout.scss';

import axios from 'axios';
import Vue from 'vue';
import Vuelidate from 'vuelidate';

// Polyfills for IE11
import 'core-js';
import 'regenerator-runtime/runtime';
import 'formdata-polyfill';

import App from './app.vue';
import { configureAxios } from './axios';
import { store, router, unsync } from './config';
import { createProvider } from './vue-apollo';

Vue.use(Vuelidate);

new Vue({
  router,
  store,
  mounted() {
    configureAxios(axios);
  },
  destroyed() {
    unsync();
  },
  apolloProvider: createProvider(),
  render: h => h(App),
}).$mount('#app');
